import { VideoCodec } from './video-format';
export var Protection;
(function (Protection) {
    Protection["Fairplay"] = "FPS";
    Protection["Marlin"] = "MS3";
    Protection["None"] = "NONE";
    Protection["PlayReady"] = "PLAYREADY";
    Protection["Widevine"] = "WIDEVINE";
})(Protection || (Protection = {}));
export var Container;
(function (Container) {
    Container["ISOBMFF"] = "ISOBMFF";
})(Container || (Container = {}));
export var Transport;
(function (Transport) {
    Transport["DASH"] = "DASH";
    Transport["HLS"] = "HLS";
    Transport["HSS"] = "HSS";
    Transport["PDL"] = "PDL";
    Transport["PSF"] = "PSF";
})(Transport || (Transport = {}));
export const NONE_DASH_ISOBMFF = {
    acodec: "AAC" /* AudioCodec.AAC */,
    container: "ISOBMFF" /* Container.ISOBMFF */,
    protection: "NONE" /* Protection.None */,
    transport: "DASH" /* Transport.DASH */,
    vcodec: VideoCodec.H264,
};
export const NONE_HLS_ISOBMFF = {
    acodec: "AAC" /* AudioCodec.AAC */,
    container: "ISOBMFF" /* Container.ISOBMFF */,
    protection: "NONE" /* Protection.None */,
    transport: "HLS" /* Transport.HLS */,
    vcodec: VideoCodec.H264,
};
export const FAIRPLAY_HLS_ISOBMFF = {
    acodec: "AAC" /* AudioCodec.AAC */,
    container: "ISOBMFF" /* Container.ISOBMFF */,
    protection: "FPS" /* Protection.Fairplay */,
    transport: "HLS" /* Transport.HLS */,
    vcodec: VideoCodec.H264,
};
export const WIDEVINE_HLS_ISOBMFF = {
    acodec: "AAC" /* AudioCodec.AAC */,
    container: "ISOBMFF" /* Container.ISOBMFF */,
    protection: "WIDEVINE" /* Protection.Widevine */,
    transport: "HLS" /* Transport.HLS */,
    vcodec: VideoCodec.H264,
};
export const PLAYREADY_DASH_ISOBMFF = {
    acodec: "AAC" /* AudioCodec.AAC */,
    container: "ISOBMFF" /* Container.ISOBMFF */,
    protection: "PLAYREADY" /* Protection.PlayReady */,
    transport: "DASH" /* Transport.DASH */,
    vcodec: VideoCodec.H264,
};
export const WIDEVINE_DASH_ISOBMFF = {
    acodec: "AAC" /* AudioCodec.AAC */,
    container: "ISOBMFF" /* Container.ISOBMFF */,
    protection: "WIDEVINE" /* Protection.Widevine */,
    transport: "DASH" /* Transport.DASH */,
    vcodec: VideoCodec.H264,
};
export const MARLIN_DASH_ISOBMFF = {
    acodec: "AAC" /* AudioCodec.AAC */,
    container: "ISOBMFF" /* Container.ISOBMFF */,
    protection: "MS3" /* Protection.Marlin */,
    transport: "DASH" /* Transport.DASH */,
    vcodec: VideoCodec.H264,
};
export const MARLIN_DASH = [MARLIN_DASH_ISOBMFF, NONE_DASH_ISOBMFF];
export const WIDEVINE_HLS = [WIDEVINE_HLS_ISOBMFF, NONE_HLS_ISOBMFF];
export const FAIRPLAY_HLS = [FAIRPLAY_HLS_ISOBMFF, NONE_HLS_ISOBMFF];
export const WIDEVINE_DASH = [WIDEVINE_DASH_ISOBMFF, NONE_DASH_ISOBMFF];
export const PLAYREADY_DASH = [PLAYREADY_DASH_ISOBMFF, NONE_DASH_ISOBMFF];
export const PLAYREADY_DASH_UHD = PLAYREADY_DASH.map((i) => ({
    ...i,
    vcodec: VideoCodec.H265,
}));
//# sourceMappingURL=playout-capability.js.map